export default __webpack_public_path__ + "static/media/about_us_desktop.27510f95.png";